import { Box, CardActions, Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRun";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import CardTitle from "@saleor/components/CardTitle";
import { maybe } from "@saleor/misc";
import {
  failedReasonsNationwideDelivery,
  isStandardDeliveryNewRTS,
  onTimeIsTrue
} from "@saleor/motherOrders/utils/handlers";
import moment from "moment-timezone";
import React from "react";
import { useIntl } from "react-intl";

import {
  DeliveryTypeEnum,
  SmopOrderStatusEnum
} from "../../../types/globalTypes";
import {
  OrderDetails_order,
  OrderDetails_order_rider,
  OrderDetails_order_thirdPartyRider
} from "../../types/OrderDetails";
import {
  LateDeliveryList,
  OpsLateDeliveryList
} from "../OrderAssignRiderDialog/initialData";

export interface OrderAssignedRiderProps {
  assignedRiderDialog: () => void;
  riderData: OrderDetails_order_rider;
  status: SmopOrderStatusEnum;
  deliveryType: DeliveryTypeEnum;
  isThirdParty: boolean;
  thirdPartyData: OrderDetails_order_thirdPartyRider;
  order: OrderDetails_order;
  disableAction: boolean;
}

const useStyles = makeStyles(
  theme => ({
    assignRiderHeader: {
      [theme.breakpoints.down("lg")]: {
        fontSize: "14px"
      }
    },
    cardContent: {
      paddingBottom: "4px"
    },
    riderDetails: {
      alignItems: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "left"
    },
    riderDetailsContent: {
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
      fontSize: "14px",
      marginBottom: "6px"
    },
    root: {
      ...theme.typography.body1,
      lineHeight: 1.9,
      width: "100%"
    },
    subLabel: {
      fontWeight: 600
    },
    textBold: {
      fontSize: "14px",
      fontWeight: 600,
      textAlign: "left"
    },
    textRight: {
      fontSize: "14px",
      textAlign: "left"
    }
  }),
  { name: "OrderAssignedRider" }
);

const OrderAssignedRider: React.FC<OrderAssignedRiderProps> = props => {
  const {
    assignedRiderDialog,
    riderData,
    status,
    deliveryType,
    isThirdParty,
    thirdPartyData: rider3Pl,
    order,
    disableAction
  } = props;
  const classes = useStyles(props);
  const intl = useIntl();

  const findLateDeliveryValue = LateDeliveryList.find(
    e => e.value === order?.lateDeliveryReason
  );
  const lateDeliveryValue = findLateDeliveryValue
    ? findLateDeliveryValue.label
    : order?.lateDeliveryReason;

  const getLateDispatchReason = value => {
    const LateDispatchReasonObj = OpsLateDeliveryList.find(
      e => e.value === value
    );
    if (!LateDispatchReasonObj) {
      return value;
    } else {
      return LateDispatchReasonObj.label;
    }
  };

  const getRiderName = () => {
    let firstName;
    let lastName;

    if (isThirdParty) {
      firstName =
        maybe(() => rider3Pl.firstName, "-") === null
          ? "-"
          : maybe(() => rider3Pl.firstName, "-");

      lastName =
        maybe(() => rider3Pl.lastName) === null
          ? ""
          : maybe(() => rider3Pl.lastName, "");
    } else {
      firstName =
        maybe(() => riderData.firstName, "-") === null
          ? "-"
          : maybe(() => riderData.firstName, "-");

      lastName =
        maybe(() => riderData.lastName) === null
          ? ""
          : maybe(() => riderData.lastName, "");
    }

    return firstName + " " + lastName;
  };

  const getRiderContactNo = () => {
    if (isThirdParty) {
      const contactNo = maybe(() => rider3Pl.contactNo, "-");
      return contactNo ?? "-";
    } else {
      const contactNo = maybe(() => riderData.contactNo, "-");
      return contactNo ?? "-";
    }
  };

  const getColorOnTime = () => {
    let color;
    if (order.onTime) {
      color = "#4ee64e";
    } else if (order.onTime !== null && order.onTime === false) {
      color = "#ff7d7d";
    } else {
      color = "#3D3D3D";
    }
    return color;
  };

  const enableChangeButton =
    ((status === SmopOrderStatusEnum.READY_TO_SHIP ||
      status === SmopOrderStatusEnum.SHIPPED ||
      ((deliveryType === DeliveryTypeEnum.EXPRESS ||
        deliveryType === DeliveryTypeEnum.EXPRESS_LONG_DISTANCE ||
        deliveryType === DeliveryTypeEnum.SAME_DAY ||
        isStandardDeliveryNewRTS(deliveryType, status)) &&
        status !== SmopOrderStatusEnum.CANCELED)) &&
      deliveryType !== DeliveryTypeEnum.NATIONWIDE_DELIVERY) ||
    failedReasonsNationwideDelivery(order?.deliveryCourier?.failedReason);

  return (
    <Card>
      <CardTitle
        customId="txtAdminFulfillmentMotherDetailsPageAssignedRider"
        title={intl.formatMessage({
          defaultMessage: "Assigned Rider",
          description: "section header"
        })}
      />

      <CardContent
        id="cmpAdminFulfillmentMotherOrderDetailsPageCardContent"
        className={classes.cardContent}
      >
        <div
          id="cmpAdminFulfillmentMotherOrderDetailsPageRiderDetails"
          className={classes.riderDetails}
        >
          <span
            id="txtAdminFulfillmentMotherOrderDetailsPageRiderName"
            className={classes.riderDetailsContent}
          >
            <DirectionsRunIcon
              style={{
                color: "#9B51E0",
                fontSize: "29px",
                marginRight: "10px"
              }}
            />
            {getRiderName()}
          </span>
          <span
            id="txtAdminFulfillmentMotherOrderDetailsPageRiderContactNo"
            className={classes.riderDetailsContent}
            style={{ marginBottom: "0px" }}
          >
            <PhoneAndroidIcon
              style={{
                color: "#9B51E0",
                fontSize: "23px",
                marginLeft: "4px",
                marginRight: "13px"
              }}
            />
            {getRiderContactNo()}
          </span>
        </div>

        {order?.shippingMethod?.deliveryType === DeliveryTypeEnum.EXPRESS ||
        order?.shippingMethod?.deliveryType ===
          DeliveryTypeEnum.EXPRESS_LONG_DISTANCE ||
        order?.shippingMethod?.deliveryType === DeliveryTypeEnum.SAME_DAY ||
        isStandardDeliveryNewRTS(deliveryType, status) ? (
          <>
            <h3
              id="txtAdminFulfillmentMotherOrderDetailsPageTransactionTime"
              style={{ marginBottom: "5px" }}
            >
              Transaction Time
            </h3>
            <div>
              <Grid container spacing={1}>
                <Grid
                  id="gridAdminFulfillmentMotherOrderDetailsPageTimeOfDispatch"
                  item
                  xs={6}
                  sm={6}
                  md={6}
                >
                  <span id="txtAdminFulfillmentMotherOrderDetailsPageTimeOfDispatch">
                    Time of Dispatch
                  </span>
                </Grid>
                <Grid
                  id="gridAdminFulfillmentMotherOrderDetailsPageTimeDelivered"
                  item
                  xs={6}
                  sm={6}
                  md={6}
                >
                  <span id="txtAdminFulfillmentMotherOrderDetailsPageTimeDelivered">
                    Time Delivered
                  </span>
                </Grid>
                <Grid
                  id="gridAdminFulfillmentMotherOrderDetailsPageShippedAt"
                  item
                  xs={6}
                  sm={6}
                  md={6}
                >
                  <span id="txtAdminFulfillmentMotherOrderDetailsPageShippedAt">
                    {" "}
                    {maybe(() => order?.shippedAt)
                      ? moment(order.shippedAt).format("hh:mm A")
                      : "--"}
                  </span>
                </Grid>
                <Grid
                  id="gridAdminFulfillmentMotherOrderDetailsPageCompletedAt"
                  item
                  xs={6}
                  sm={6}
                  md={6}
                >
                  <span id="txtAdminFulfillmentMotherOrderDetailsPageCompletedAt">
                    {maybe(() => order?.completedAt)
                      ? moment(order.completedAt).format("hh:mm A")
                      : "--"}
                  </span>
                </Grid>
                <Grid
                  id="gridAdminFulfillmentMotherOrderDetailsPageShipped"
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span
                    id="txtAdminFulfillmentMotherOtherDetailsTime"
                    className={classes.subLabel}
                  >
                    Dwell Time
                  </span>
                  <span id="txtMthrOrdrDtlsPgRdrDwelTime">
                    {order.dwellTime ? order.dwellTime : "--"}
                  </span>
                </Grid>
                <Grid
                  id="gridAdminFulfillmentMotherOtherDetailsPageTime"
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span
                    id="txtAdminFulfillMotherOtherDetailsLongTime"
                    className={classes.subLabel}
                  >
                    Total Time
                  </span>
                  <span id="txtAdminFulfillmentMotherOtherDetailsTotalTime">
                    {order.totalTime ? order.totalTime : "--"}
                  </span>
                </Grid>
                <Grid
                  id="gridMthrOrdrDtlsPgRdrStatus"
                  item
                  xs={6}
                  sm={6}
                  md={6}
                >
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingRight: "26px"
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {" "}
                      <span
                        id="txtAdminFulfillmentMotherOtherStatus"
                        className={classes.subLabel}
                      >
                        Status
                      </span>{" "}
                      <span id="txtAdminFulfilmentMotherOrderOnTime">
                        On Time
                      </span>
                    </div>
                    <h4
                      id="h4AdminFulfilmentMotherOrderOnTime"
                      style={{
                        color: getColorOnTime()
                      }}
                    >
                      {order?.onTime !== null
                        ? onTimeIsTrue(order.onTime)
                        : "--"}
                    </h4>
                  </Box>
                </Grid>
                <Grid
                  id="gridAdminFulfilmentMotherOrderOnTime"
                  item
                  xs={12}
                  sm={12}
                  md={12}
                >
                  <h3
                    style={{
                      margin: "0px"
                    }}
                  >
                    <span id="txtAdminFulfilmentMother">
                      Ops Admin Reason for Late Delivery
                    </span>
                  </h3>
                  <span id="txtAdminFulfilmentMotherOrderOpsAdminReasonLateDelivery">
                    {maybe(() => order?.lateDispatchReason, "--")
                      ? getLateDispatchReason(order?.lateDispatchReason)
                      : "--"}
                  </span>
                </Grid>
                <Grid
                  id="gridAdminFulfilmentMotherOrderOpsAdminReasonLateDelivery"
                  item
                  xs={12}
                  sm={12}
                  md={12}
                >
                  <h3
                    id="h3AdminFulfilmentMotherOrderRiderReasonLaterDelivery"
                    style={{
                      margin: "0px"
                    }}
                  >
                    <span>Rider Reason for Late Delivery</span>
                  </h3>
                  <span>{lateDeliveryValue || "--"}</span>
                </Grid>
              </Grid>
            </div>
          </>
        ) : null}
      </CardContent>

      <CardActions id="cmpAdminFulfilmentMotherOrderChange">
        <Button
          id="btnAdminFulfilmentMotherOrderChange"
          disabled={!enableChangeButton || disableAction}
          variant="contained"
          color="primary"
          fullWidth
          onClick={assignedRiderDialog}
        >
          Change
        </Button>
      </CardActions>
    </Card>
  );
};

OrderAssignedRider.displayName = "AssignedRider";
export default OrderAssignedRider;
